import { assign, groupBy } from 'lodash';
import { ActionType } from '../actions/actions';
import { IAction } from '../../classes/action';
import { defaultFestivalOverviewAppModel } from './festival-reducer';
import { Day } from '../../classes/day';

export interface FestivalOverviewSettingsModel {
    rightWYSIWYG: string;
    leftWYSIWYG: string;
    currentDay: string;
    dayList: string[];
    emptyDayList: string[];
    mobileDayList: string[];
    requestingSettings: boolean;
    pageId: string;

}

export const defaultFestivalOverviewSettingsModel: FestivalOverviewSettingsModel = {
    currentDay: '',
    leftWYSIWYG: '',
    dayList: [],
    emptyDayList: [],
    mobileDayList: [],
    rightWYSIWYG: '',
    requestingSettings: false,
    pageId: '',
};

export default function festivalOverviewSettingsReducer(state: FestivalOverviewSettingsModel = defaultFestivalOverviewSettingsModel, action: IAction) {
    switch (action.type) {
        case ActionType.REQUEST_SETTINGS: {
            return assign({}, state, { requestingSettings: true });
        }
        case ActionType.RECEIVE_SETTINGS: {
            const festivalOverviewSettings = action.value.festivalOverviewSetting;
            const rightWYSIWYG = festivalOverviewSettings.rightWYSIWYG;
            const leftWYSIWYG = festivalOverviewSettings.leftWYSIWYG;
            const dayList = festivalOverviewSettings.dayList;
            const currentDay = festivalOverviewSettings.currentDay;
            const emptyDayList = festivalOverviewSettings.emptyDayList;
            const mobileDayList = festivalOverviewSettings.mobileDayList;
            return assign({}, state, { requestingSettings: false, rightWYSIWYG: rightWYSIWYG, leftWYSIWYG: leftWYSIWYG, dayList: dayList, emptyDayList: emptyDayList, mobileDayList: mobileDayList, currentDay: currentDay });
        }
        case ActionType.SET_PAGE_ID: {
            const pageId = action.value;
            return assign({}, state, { pageId: pageId })
        }
        default:
            return state;
    }
}